import { createSlice } from "@reduxjs/toolkit";
import { Room } from "../types/index.js";
import { fetch } from "../utils/utils.js";
import { showAlert } from "./alerts.js";
import { createAppAsyncThunk } from "./utils.js";

const sliceName = "rooms";

const initialState: Room[] = [];

export const getRooms = createAppAsyncThunk(
  `${sliceName}/getRooms`,
  async (siteId: string, { dispatch }) => {
    try {
      const { data } = await fetch({
        dispatch,
        languageId: "de",
        authorize: false,
      }).get<Room[]>(`sites/${siteId}/rooms`);
      return data;
    } catch (error) {
      dispatch(
        showAlert("Beim Laden der Zimmer-Daten ist ein Fehler aufgetreten!"),
      );
      throw error;
    }
  },
  {
    condition: (_siteId, { getState }) => {
      const loadState = getState().loadStates.rooms;
      return loadState === "unloaded" || loadState === undefined;
    },
  },
);

const slice = createSlice({
  name: sliceName,
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getRooms.fulfilled, (_state, action) => action.payload);
  },
});

export default slice.reducer;
